import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose, hoistStatics, withState, lifecycle, withHandlers, defaultProps, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import Documents from './Documents';
import ModuleService from '../../../services/module.service';
import DocumentService from '../../../services/document.service';
import dh from '../../../helpers/document.helper';
import WithLoading from '../../../components/WithLoading';
import { settingsActions } from '../../../reducers/settings';


const defaultCriteria = {
  page: 0,
  limit: 10,
  sortBy: 'created_at',
  order: 'desc',
  original: '',
  parent_id: '',
};

const goToPage = props => async (nextPage) => {
  const { criteria, setCriteria, setDocumentsCount, setGroupedDocs, t } = props;
  const page = nextPage > -1 ? nextPage : 0;
  const { data, count } = await DocumentService.getData({ ...criteria, page });
  setDocumentsCount(count);
  setCriteria({ ...criteria, page });
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
  const groupedDocs = dh.groupDocuments(t, data);
  setGroupedDocs(groupedDocs);
};

const changeFilter = props => async (filters) => {
  const { criteria } = props;
  const newCriteria = { ...criteria };
  for (let i = 0; i < filters.length; i++) {
    newCriteria[filters[i].name] = filters[i].value;
  }
  await goToPage({ ...props, criteria: newCriteria })(0);
};

const resetFilter = props => async () => {
  await goToPage({ ...props, criteria: defaultCriteria })(0);
};

const chooseDoc = props => (e, doc) => {
  e.preventDefault();
  const { history } = props;
  if (doc.is_folder) {
    history.push(DocumentService.getFolderUrl(doc.id));
  } else {
    history.push(DocumentService.getDocUrl(doc.id, doc.parent_id));
  }
};

const callbackToSetSearch = props => async (value) => {
  const { criteria } = props;
  await goToPage({ ...props, criteria: { ...criteria, original: value } })(0);
};

const loadFolder = props => async (newFolderId) => {
  if (newFolderId) {
    const folder = await DocumentService.get(newFolderId);
    if (!folder || !folder.is_folder) {
      return props.history.push(DocumentService.getBaseUrl());
    }
    await props.setCriteria({
      ...props.criteria,
      parent_id: newFolderId,
    });
    await props.setFolder(folder);
  } else {
    await props.setCriteria({
      ...props.criteria,
      parent_id: newFolderId,
    });
    await props.setFolder(null);
  }
};

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('folder', 'setFolder', null),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('groupedDocs', 'setGroupedDocs', {}),
  withState('documentsCount', 'setDocumentsCount', 0),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].title || props.t('Documents'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].color ?
      props.modulesSettings[ModuleService.TYPE_DOCUMENTS].color : props.modulesSettings[ModuleService.TYPE_DOCUMENTS].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].enable_cover_color,
    getDatesNames: DocumentService.getDatesNames(props),
  })),
  defaultProps({
  }),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, updateSettings, match } = this.props;
      await loadFolder(this.props)(match.params.folder_id);
      updateSettings({ hasLoadedPage: false });
      await goToPage(this.props)(0);
      setIsLoading(false);
      updateSettings({ hasLoadedPage: true });
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.folder_id !== this.props.match.params.folder_id) {
        await loadFolder(nextProps)(nextProps.match.params.folder_id);
        await goToPage(this.props)(0);
      }
    },
  }),
  withHandlers({
    goToPage,
    chooseDoc,
    resetFilter,
    changeFilter,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Documents)));



// WEBPACK FOOTER //
// ./src/views/modules/documents/index.js